import { render, staticRenderFns } from "./DeptTeams.vue?vue&type=template&id=b99d8666"
import script from "./DeptTeams.vue?vue&type=script&lang=js"
export * from "./DeptTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports